import { useMemo } from 'react';
import { useDevice } from './useDevice';
import { getProductCapabilities, type ProductCapabilities } from '@/lib/product-capabilities';

export function useProductCapabilities(): ProductCapabilities {
  const { selectedDeviceInfo, selectedDevice } = useDevice();

  return useMemo(() => {
    const deviceType =
      selectedDeviceInfo?.deviceProperties?.deviceType ??
      selectedDevice?.deviceProperties?.deviceType;
    return getProductCapabilities(deviceType);
  }, [selectedDeviceInfo, selectedDevice]);
}
